var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7605 18.1346C15.0365 18.1346 16.2255 17.7446 17.226 17.0846L20.764 20.7446L22.823 18.6146L19.285 14.9696C19.923 13.9196 20.3 12.7046 20.3 11.3846C20.3 7.64964 17.3855 4.63464 13.775 4.63464C10.1645 4.63464 7.25 7.64964 7.25 11.3846C7.25 15.1196 10.1645 18.1346 13.7605 18.1346ZM13.775 7.63464C15.776 7.63464 17.4 9.31464 17.4 11.3846C17.4 13.4546 15.776 15.1346 13.775 15.1346C11.774 15.1346 10.15 13.4546 10.15 11.3846C10.15 9.31464 11.774 7.63464 13.775 7.63464ZM26.1 0.134644H2.9C1.305 0.134644 0 1.48464 0 3.13464V21.1346C0 22.7846 1.305 24.1346 2.9 24.1346H26.1C27.695 24.1346 29 22.7846 29 21.1346V3.13464C29 1.48464 27.695 0.134644 26.1 0.134644ZM26.1 21.1346H2.9V3.13464H26.1V21.1346Z",
    fill: "#FD5C38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewOutline);
export default __webpack_public_path__ + "static/media/overview-outline.ba731a93ae1558efc944fe3a298c2557.svg";
export { ForwardRef as ReactComponent };